var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[(_vm.content.aside)?_c('p',{staticClass:"aside"},[_vm._v(_vm._s(_vm.content.aside))]):_vm._e(),_c('h1',{staticClass:"main-headline"},[_vm._v(_vm._s(_vm.content.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }